<template>
    <v-card class="form-container">
        <v-textarea
            v-model="textTemplate"
            class="form-field"
            label="SMS text template, You can use up to 2 placeholder(s)"
            hint="Click on the buttons below to insert a placeholder to your SMS text, each placeholder represents column 2 and above. Column 1 is reserved for your recipient(s) list."
        />
        <div class="params-container">
            <div
                v-for="param in 5"
                :key="param"
            >
                <v-btn
                    color="cyan"
                    dark
                    @click="addParamInText(param)"
                >
                    Param {{ param }}
                </v-btn>
            </div>
        </div>
        <v-btn
            color="primary"
            :loading="submitLoading"
            :disabled="submitLoading"
            @click="updateCampaign()"
        >
            Update
        </v-btn>
        <v-btn text @click="cancel()">
            Cancel
        </v-btn>
    </v-card>
</template>

<script>
    export default {
        props: {
            campaign: {
                type: Object,
                required: true
            },
            submitLoading: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                textTemplate: ''
            }
        },
        watch: {
            campaign(newVal) {
                this.textTemplate = newVal.textTemplate
            }
        },
        methods: {
            addParamInText(param) {
                this.textTemplate += ` {PARAM${param}} `
            },
            updateCampaign() {
                this.$emit('updateCampaign', this.textTemplate)
            },
            cancel() {
                this.$emit('cancel')
            }
        }
    }
</script>

<style scoped>

.params-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 15px;
    margin-bottom: 20px;
    gap: 10px;
}

.form-container {
    padding: 1rem;
}

.form-field {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

</style>
